/* eslint-disable @typescript-eslint/consistent-type-assertions -- RNW supports rem values, but RN's style types require numbers. */

import type { TextStyle } from "react-native";

const DEFAULT_ROOT_FONT_SIZE = 16;

function pixelsToRem(value: number): string {
  return `${value / DEFAULT_ROOT_FONT_SIZE}rem`;
}

export function normalizeTextStyle(style: TextStyle): TextStyle {
  return {
    ...style,
    ...(typeof style.fontSize === "number"
      ? { fontSize: pixelsToRem(style.fontSize) as unknown as number }
      : {}),
    ...(typeof style.lineHeight === "number"
      ? { lineHeight: pixelsToRem(style.lineHeight) as unknown as number }
      : {}),
  };
}
